
import React from 'react'
import './Translate.scss'

export default () => (
  <svg className="translate-icon" viewBox="0 0 14 14" focusable="false" aria-hidden="true">
    <path
      d="M1 2.33333H9.8421M1.63158 10.3333C1.63158 10.3333 3.41591 9.60892 5.35576 7.30045M5.35576 7.30045C6.3583 6.1074 7.40238 4.49125 8.26316 2.33333M5.35576 7.30045C3.74645 5.6533 3.21053 4.33333 3.21053 4.33333M5.35576 7.30045C5.88612 7.84328 6.53305 8.42164 7.31579 9M5.10526 2.33333V1M12.2249 11L10.1579 5.66667L8.09091 11M12.2249 11L13 13M12.2249 11H8.09091M7.31579 13L8.09091 11"
      stroke="#6F767C"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
